module.exports = require("@splunk/visualizations-shared/VisualizationDocPage");